var map = {
	"./cash-icon-home-mobile.webp": 1610,
	"./cashout-icon-home-mobile.webp": 1611,
	"./transfer-icon-home-mobile.webp": 1612,
	"./vip-icon-home-mobile-active.webp": 1613,
	"./vip-icon-home-mobile.webp": 1614,
	"./wallet-icon-home-mobile.webp": 1615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 740;